import COLORS from '@/constants/colors';

export default {
  nav: {
    '& a.active': {
      backgroundColor: '#EFF2F7',
    },
    '& a svg': {
      display: 'block',
    },
    horizontal: {
      borderBottom: `1px solid ${COLORS.gray_4}`,
      '& a.active': {
        fontWeight: '600 !important',
        color: `${COLORS.mercanto_blue} !important`,
        '&::after': {
          content: "''",
          display: 'block',
          position: 'absolute',
          // top: '0',
          right: '0',
          bottom: '-2.5px',
          left: '0',
          backgroundColor: COLORS.mercanto_blue,
          height: '4px',
          borderRadius: '50px',
        },
      },
    },
  },
};
